export const MODAL_OPEN = 'Payer onboarding. Schedule a demo in Google Calendar. Modal opened'
